export default __webpack_public_path__ + "static/media/beforeribboncut_w1024.dcbbcada.jpeg";